(() => {
  if (customElements.get('hatchill-footer-navigation')) return;
  customElements.define('hatchill-footer-navigation', class extends HTMLElement {
    connectedCallback() {
      this.media = window.matchMedia('(max-width: 749px)');
      this.present = () => {
        for (const group of this.querySelectorAll('[data-footer-group]')) {
          const summary = group.querySelector('summary');
          summary.tabIndex = this.media.matches ? 0 : -1;
          group.open = !this.media.matches || group.contains(document.activeElement);
        }
      };
      this.onClick = event => {
        const summary = event.target.closest('summary');
        if (!this.media.matches && summary && this.contains(summary)) event.preventDefault();
      };
      this.media.addEventListener('change', this.present);
      this.addEventListener('click', this.onClick);
      this.present();
    }
    disconnectedCallback() {
      this.media?.removeEventListener('change', this.present);
      this.removeEventListener('click', this.onClick);
    }
  });
})();
